import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const fetchUserCountInfo = createAsyncThunk("user/info/count", async (reqbody) => {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(reqbody)
  };
  const response = await fetch(process.env.REACT_APP_API_URL + "api/getactiveuserscount", requestOptions);
  const res = await response.json();

  return res;
});




const userInfoReducer = createSlice({
  name: 'userInfoReducer',
  initialState: {
    userCount: null,
    userData: {},
    loading: false,
    message: null,
    messageflag: false,
  },

  reducers: {
    setMessagefterSubmit(state, action) {
      state.messageflag = false;
      state.message = null;
    }
  },
  extraReducers: {
    [fetchUserCountInfo.rejected]: (state, action) => {
      state.loading = false;
    },
    [fetchUserCountInfo.pending]: (state, action) => {
      state.loading = true;
    },
    [fetchUserCountInfo.fulfilled]: (state, action) => {
      state.loading = false;
      if (action.payload.status === 'success') {
        state.userCount = action.payload.result
      }
    },

  }
})

export default userInfoReducer.reducer;
export const { setMessagefterSubmit } = userInfoReducer.actions;